export default __webpack_public_path__ + "static/media/logo-marketplace.1b812041.svg";